import { Component, OnInit } from '@angular/core';
import { ISODateString } from '@capacitor/core';
import { ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { FrozenStructure } from '../../_interfaces/frozen-structure';
import { UsersService } from '../../users.service';

@Component({
    selector: 'app-my-dialog',
    templateUrl: './frozen-structure.modal.html',
    styleUrls: ['./frozen-structure.modal.scss']
})
export class FrozenStructureModalComponent extends BaseClass implements OnInit {

    public frozenStructure: FrozenStructure = {
        Enabled: false,
        StartDate: "",
        EndDate: "",
        TotalFreezingStartDate: "",
        TotalFreezingEndDate: "",
    };

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _usersService: UsersService,) {
        super(_toastController, _translationService);
    }

    async ngOnInit() {
        await this._usersService.getLastFrozenStructure().subscribe((response) => {
            if (response.data) {
                this.frozenStructure =
                {
                    Enabled: response.data.enabled,
                    StartDate: response.data.startDate !== "0001-01-01T00:00:00+00:00" ? response.data.startDate : "",
                    EndDate: response.data.endDate !== "0001-01-01T00:00:00+00:00" ? response.data.endDate : "",
                    TotalFreezingStartDate: response.data.startDate !== "0001-01-01T00:00:00+00:00" ? response.data.totalFreezingStartDate : "",
                    TotalFreezingEndDate: response.data.endDate !== "0001-01-01T00:00:00+00:00" ? response.data.totalFreezingEndDate : "",
                };
            }
        }, (error) => this.notify(this.getErrorNotification(error), 'danger'));
    }

    public async saveFrozenStructure() {
        if (this.frozenStructure.Enabled) {
            if (this.frozenStructure.StartDate
                && this.frozenStructure.EndDate
                && this.frozenStructure.TotalFreezingStartDate
                && this.frozenStructure.TotalFreezingStartDate
            ) {
                if (this.frozenStructure.EndDate < this.frozenStructure.StartDate) {
                    await this.notify(this._translationService.getTranslation("frozenStructure.endDateBeforeStartDate"), 'danger');
                    return;
                }

                if (this.frozenStructure.TotalFreezingEndDate
                    && this.frozenStructure.TotalFreezingStartDate
                    && this.frozenStructure.TotalFreezingEndDate < this.frozenStructure.TotalFreezingStartDate) {
                    await this.notify(this._translationService.getTranslation("frozenStructure.totalFreezingEndDateBeforeStartDate"), 'danger');
                    return;
                }
            }
            else {
                await this.notify(this._translationService.getTranslation("frozenStructure.insertAllFrozenDates"), 'danger');
                return;
            }
        }

        this.frozenStructure =
        {
            Enabled: this.frozenStructure.Enabled,
            StartDate: this.frozenStructure.StartDate,
            EndDate: this.frozenStructure.EndDate,
            TotalFreezingStartDate: this.frozenStructure.TotalFreezingStartDate,
            TotalFreezingEndDate: this.frozenStructure.TotalFreezingEndDate,
        };
        this._usersService.addFrozenStructure(this.frozenStructure).subscribe((response) => {
            if (response.success) {
                this.notify(this._translationService.getTranslation("frozenStructure.success"), 'success');
                this._modalController.dismiss(response.success);
            }
        }, (error) => this.notify(this.getErrorNotification(error), 'danger'));
    }

    public async back() {
        await this._modalController.dismiss();
    }
}
